import { Box, Typography, useTheme } from '@mui/material';
import { event } from '../cal/interfaces';
import { tokens } from '../../../global/theme/tokens';
import AddIcon from '@mui/icons-material/Add';
import LoopIcon from '@mui/icons-material/Loop';
import { TimeLabel } from '../../label/TimeLabel';
import moment from 'moment';
import { useEffect, useState } from 'react';

export const ExoCalWholeDayEvents = ({
  event,
  isFirst,
  isLast,
  isFirstInWeek,
  date,
  isSelected,
  onEventSelect,
  onEventEdit,
  selectedPeriod,
}: {
  event: event;
  isFirst: Boolean;
  isLast: Boolean;
  isFirstInWeek: Boolean;
  date: string;
  isSelected: Boolean;
  onEventSelect: Function;
  onEventEdit: Function;
  selectedPeriod: string;
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const { category, calendar } = event || {};

  const typeMap = {
    new: { color: colors.info, Icon: AddIcon },
  };
  const Icon = typeMap[event.type]?.Icon;

  const isWholeDay = event.wholeDay;

  // mobile view
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1200);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1200);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      onClick={(e) => onEventSelect(e, event)}
      onDoubleClick={(e) => onEventEdit(e, event)}
      style={{
        paddingLeft: isFirst ? (isSmallScreen ? '1px' : '4px') : '0px',
        paddingRight: isLast ? (isSmallScreen ? '2px' : '4px') : '0px',
        cursor: calendar?.id ? 'pointer' : 'auto',
      }}
      data-date={date}
      className="flex justify-start items-center w-full cursor-pointer h-[24px] relative py-[2px]"
    >
      <Box
        className="w-full flex justify-start items-center h-full px-[2px] rounded-sm"
        sx={{
          borderRadius: `${isFirst ? '10px' : '0px'} ${
            isLast ? '10px' : '0px'
          } ${isLast ? '10px' : '0px'} ${isFirst ? '10px' : '0px'}`,

          borderWidth: '1px',
          borderTopColor: isSelected ? colors.info + '80' : `transparent`,
          borderBottomColor: isSelected ? colors.info + '80' : `transparent`,
          borderLeftColor:
            isSelected && (isFirst || isFirstInWeek)
              ? colors.info + '80'
              : `transparent`,
          borderRightColor:
            isSelected && isLast ? colors.info + '80' : `transparent`,
          backgroundColor: isSelected
            ? colors.info + '40'
            : isWholeDay
              ? (category?.color || event.color || typeMap[event.type]?.color) +
                'AA'
              : (category?.color || event.color || typeMap[event.type]?.color) +
                '40',
        }}
      >
        <Box
          className="flex flex-col lg:flex-row justify-between w-full items-center overflow-hidden"
          sx={{
            justifyContent: isFirst ? 'space-between' : 'end',
          }}
        >
          {(selectedPeriod === 'day'
            ? isFirstInWeek || isFirst || !isFirst
            : isFirstInWeek || isFirst) && (
            <>
              {category?.icon && (
                <img
                  src={category?.icon?.temporaryUrl}
                  className="w-[15px] h-[15px] mr-[2px] hidden lg:block"
                />
              )}
              <Typography
                fontWeight={500}
                sx={{
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  paddingLeft: '5px',
                }}
                fontSize="11px"
                className="w-full text-left line-clamp-1"
              >
                {Icon && <Icon fontSize="10px" sx={{ marginLeft: '3px' }} />}
                <span>{event.label}</span>
                {event?.seriesMasterId && (
                  <LoopIcon
                    sx={{
                      fontSize: '11px',
                      marginRight: '3px',
                      verticalAlign: 'middle',
                      opacity: 0.6,
                    }}
                  />
                )}
              </Typography>
            </>
          )}
        </Box>
      </Box>
    </div>
  );
};
